import chatActions from "actions/chat";
import cn from "classnames";
import Avatar from "components/shared/avatar";
import BookIndex from "components/shared/book/list";
import Filter from "components/shared/chat/body/filter";
import { Transition } from "components/shared/column";
import ExpressBidIcon from "components/shared/expressBidIcon";
import List from "components/shared/list";
import Loader from "components/shared/loader";
import Notifys from "components/shared/notifys";
import WithMentions from "components/shared/withMentions";
import { useUnreadItems } from "contexts/unreadItemsContext";
import { dateTimeToView } from "helpers/date";
import { bidChatDomainTypesEnum, chatTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { connect, generatedActions, tableDispatchToProps, tableStateToProps } from "helpers/redux";
import { mergeFilters } from "helpers/reqparams";
import { ymEvent } from "helpers/system";
import React from "react";
import { CustomScroll } from "react-custom-scroll";
import { Link } from "react-router-dom";
import { addChatToFavorites, removeChatFromFavorites } from "sources/messages";
import MainFilter from "./filter";

const ChatRow = (props) => {
    const { interlocutor, text, chat, unreadMessagesCount, lastMessageDate, className, isExpressBid } = props.row;
    const { chatType, loadingItems, setLoadingItems } = props;
    const { id, type, description, isFavorite } = chat;

    const { readItems } = useUnreadItems();
    const toggleFavorite = (e) => {
        e.stopPropagation();
        if (loadingItems.includes(id)) {
            return;
        }

        setLoadingItems(loadingItems.concat(id));

        props.toggleFavorite({ id, isFavorite: !isFavorite });
        (isFavorite ? removeChatFromFavorites({ chatId: id }) : addChatToFavorites({ chatId: id })).then((res) => {
            setLoadingItems(loadingItems.filter((item) => item !== id));
            if (!res) {
                props.toggleFavorite({ id, isFavorite });
            }
        });
    };

    const toChat = (id, unreadMessagesCount) => {
        if (unreadMessagesCount > 0) {
            readItems({ chatId: id, chatType });
        }
        props.toChat(id);
    };

    return (
        <div
            className={cn("book-tr book-tr--col chat__item", {
                "loading loading--small": loadingItems.includes(id),
                [className]: !!className,
            })}
            onClick={() => toChat(id, unreadMessagesCount)}
        >
            {[chatTypesEnum.Simple, chatTypesEnum.BidChat, chatTypesEnum.DriverChat].includes(type) ? (
                <div className="book-tr__td-head">
                    {interlocutor.imageUrl !== "" && (
                        <Avatar cname="book-tr__td-avatar" imageUrl={interlocutor.imageUrl} />
                    )}
                    {interlocutor.imageUrl === "" && (
                        <div className="avatar book-tr__td-avatar book-tr__td-avatar--system" />
                    )}
                    <div className="book-tr__td-title">
                        {isExpressBid && <ExpressBidIcon />}
                        <span>
                            {interlocutor.name
                                ? `${interlocutor.name}${description ? ` - ${description}` : ""}`
                                : "Без названия"}
                        </span>
                    </div>
                    <div className="book-tr__td-date">
                        <i
                            className={cn("chat__favorite-icon icon-uEABA-star-solid", {
                                "chat__favorite-icon--selected": isFavorite,
                            })}
                            onClick={toggleFavorite}
                        />
                        {dateTimeToView(lastMessageDate)}
                    </div>
                </div>
            ) : type === chatTypesEnum.System ? (
                <div className="book-tr__td-head">
                    <div className="avatar book-tr__td-avatar book-tr__td-avatar--system" />
                    <div className="book-tr__td-title">Система</div>
                    <div className="book-tr__td-date">
                        <i
                            className={cn("chat__item__favorite-icon icon-uEABA-star-solid", {
                                "chat__item__favorite-icon--selected": isFavorite,
                            })}
                        />
                        {dateTimeToView(lastMessageDate)}
                    </div>
                </div>
            ) : null}
            <div className="d-flex justify-content-between">
                <div className="book-tr__td-body ellipsis">
                    <WithMentions text={text} />
                </div>
                <Notifys count={unreadMessagesCount} chatType={chatType} />
            </div>
        </div>
    );
};

const ChatHead = (props) => {
    const { title, params, close, setFilter, chatType, modal } = props;
    const { readAllItems } = useUnreadItems();

    const readAllMessages = () => {
        return modal({
            name: "confirm",
            title: "Подтверждение действия",
            text: `Вы уверены, что хотите отметить все ${chatType === chatTypesEnum.BidChat ? "уведомления" : "сообщения"} прочитанными?`,
            callback: null,
            action: () => readAllItems({ chatType }),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    return (
        <div className="book-list__head">
            <div className="book-list__head-close close close--sm" onClick={close} />
            <div className="book-list__head-title">
                {title}
                <div className="ml-2 btn btn-xs btn-outline-primary" onClick={readAllMessages}>
                    <i className="icon-uEA54-checkmark inline-icon mr-1 small" />
                    Прочитать все
                </div>
            </div>
            <div className="btn-toolbar">
                <div className="mr-2 d-flex align-items-center">
                    <div
                        className={cn("b-filter__tag--wrap mb-0", {
                            "b-filter__tag--wrap-selected": params.customFilters?.onlyNew,
                        })}
                        onClick={() => setFilter({ name: "onlyNew", value: !params.customFilters?.onlyNew })}
                    >
                        <span
                            className={
                                params.customFilters?.onlyNew ? "b-filter__tag--delete" : "b-filter__tag--checkbox"
                            }
                        />
                        <span className="b-filter__tag--text">Непрочитанные</span>
                    </div>
                </div>
                <Link
                    to={`${paths.profileAccount}?tab=notification-settings`}
                    className="font-size-12 nowrap-text"
                    onClick={() => ymEvent("NotificationsSettingsClicked")}
                >
                    <i className="icon-uEA0C-gear inline-icon pr-1" />
                    Настройки уведомлений
                </Link>
            </div>
        </div>
    );
};

class ChatsList extends BookIndex {
    state = { loadingItems: [] };

    renderHead = () => (
        <ChatHead
            title={this.props.title}
            params={this.props.params}
            close={this.close}
            modal={this.props.modal}
            setFilter={this.setFilter}
            chatType={this.props.chatType}
        />
    );

    renderTableRow = (rowData) => {
        const {
            unreadMessagesCount,
            chat: { id },
        } = rowData;

        return (
            <ChatRow
                key={`${id}_${unreadMessagesCount}`}
                row={rowData}
                loadingItems={this.state.loadingItems}
                chatType={this.props.chatType}
                setLoadingItems={(newItems) => this.setState({ loadingItems: newItems })}
                toggleFavorite={this.props.toggleFavorite}
                toChat={this.props.toChat}
            />
        );
    };

    getList = ({ filters, ...params }) => {
        const { getList, chatType, maxCount } = this.props;

        if (chatType === chatTypesEnum.DriverChat) {
            params.queryFilter.type = bidChatDomainTypesEnum.Secondary;
        }

        getList({
            ...params,
            maxCount,
            filters: [
                {
                    dataIndex: "chat/type",
                    value:
                        chatType === chatTypesEnum.DriverChat
                            ? chatTypesEnum.DriverChat
                            : { ne: chatTypesEnum.DriverChat },
                },
            ],
        });
    };

    renderListComponent = () => {
        return (
            <>
                {this.props.isLoadingList && (
                    <div className="loader-snippet--disable-loader">
                        <Loader />
                    </div>
                )}
                <OverridedList
                    {...this.props}
                    getList={this.getList}
                    renderRow={this.renderTableRow}
                    chatType={this.props.chatType}
                />
            </>
        );
    };

    applyFilterToParams = ({ name, value }, params) => {
        if (!value || (Array.isArray(value) && value.length === 0)) {
            const queryKey = name === "transportColumn" ? "transportColumnIds" : name === "car" ? "carIds" : name;
            delete params.queryFilter[name];
            delete params.customFilters[name];
            delete params.queryFilter[queryKey];
            delete params.customFilters[queryKey];
            if (name === "onlyNew") {
                delete params.preparedFilter?.unreadMessagesCount;
            }
            return;
        }

        params.customFilters ||= {};
        params.queryFilter ||= {};

        switch (name) {
            case "onlyNew":
                params.customFilters[name] = value;
                params.preparedFilter = { unreadMessagesCount: { gt: 0 } };
                break;
            case "transportColumn":
                params.queryFilter.transportColumnIds = value;
                params.customFilters.transportColumnIds = value;
                delete params.queryFilter.carIds;
                delete params.customFilters.carIds;
                break;
            case "car":
                delete params.queryFilter.transportColumnIds;
                delete params.customFilters.transportColumnIds;
                params.queryFilter.carIds = value;
                params.customFilters.carIds = value;
                break;
            default:
                params.customFilters[name] = value;
                params.queryFilter[name] = value;
                break;
        }
    };

    setFilter = ({ name, value }) => {
        const { params, mergeParams } = this.props;
        params.start = 0;
        this.applyFilterToParams({ name, value }, params);
        mergeFilters(mergeParams, { name: "custom", value: null }, params);
    };

    setMultipleFilters = (arr) => {
        const { params, mergeParams } = this.props;
        params.start = 0;
        arr.forEach((item) => {
            this.applyFilterToParams(item, params);
        });
        mergeFilters(mergeParams, { name: "custom", value: null }, params);
    };

    resetFilters = () => {
        const { params, mergeParams } = this.props;
        params.start = 0;
        params.customFilters = {};
        params.queryFilter = {};
        params.preparedFilter = {};
        mergeFilters(mergeParams, { name: "custom", value: null }, params);
    };

    render() {
        const { listRoute, params } = this.props;
        return (
            <Transition dir="full" {...listRoute}>
                <div className="page-book__list book-list list book-list--nofilter">
                    {this.renderHead()}
                    <div className="mb-2 col-auto">
                        <MainFilter
                            setFilter={this.setFilter}
                            setMultipleFilters={this.setMultipleFilters}
                            resetFilters={this.resetFilters}
                            filters={params.customFilters ?? {}}
                            refreshData={() => this.props.mergeParams()}
                        />
                    </div>
                    {this.renderListComponent()}
                </div>
            </Transition>
        );
    }
}

class OverridedList extends List {
    renderItems = () => {
        const { renderRow, items } = this.props;
        return items && items.length ? (
            items.map((rest) =>
                renderRow({ ...rest, className: this.context.prevItemId === rest.chat.id ? "book-tr__prev-row" : "" }),
            )
        ) : (
            <span className="list__body-empty">Не найдено</span>
        );
    };

    render() {
        const { isTable, chatType, params, mergeParams } = this.props;
        const filterProps = {
            positionStatic: true,
            filterItems: (data) => {
                if (data.filter.type?.in) {
                    params.queryFilter ||= {};
                    params.queryFilter.messageTypes = data.filter.type?.in;
                } else {
                    delete params.queryFilter.messageTypes;
                }
                mergeFilters(mergeParams, { name: "custom", value: null }, params);
            },
            params: { filter: { type: { in: params.queryFilter?.messageTypes } } },
            profile: this.props.profile,
        };
        return (
            <>
                {chatType === chatTypesEnum.BidChat && <Filter {...filterProps} />}
                <div className="list__body-wrap list__body-wrap">
                    <div className="list__body content-wrapper">
                        <CustomScroll
                            heightRelativeToParent="100%"
                            ref={(el) => (this.scrollContainer = el)}
                            onScroll={this.scrollHandler}
                        >
                            <div className="chat__list">{isTable ? this.renderTable() : this.renderItems()}</div>
                        </CustomScroll>
                    </div>
                    {this.renderPagination()}
                </div>
            </>
        );
    }
}

export { ChatsList };

export default connect(
    (state) => tableStateToProps(state, "chats"),
    (dispatch) => ({
        toggleFavorite: (params) => dispatch(chatActions.toggleFavorite(params)),
        ...tableDispatchToProps(dispatch, generatedActions.chats),
    }),
)(ChatsList);
